var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "gwnl-auto-wrap" },
        [
          _c(
            "div",
            { staticClass: "mr32" },
            [
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.addEvalUsers } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("pc_gwnl_eval_btn_addTesters" /* 添加测评人员 */)
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.showImportRelation } },
                [_vm._v("\n      " + _vm._s(_vm.importBatchTitle) + "\n      ")]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { disabled: !_vm.multipleSelection.length, plain: "" },
                  on: { click: _vm.batchDeleteRow },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("pc_gwnl_global_batchDelete" /* 批量删除 */)
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          !_vm.isOpenEnv
            ? [
                _c(
                  "yxt-input",
                  {
                    staticClass: "width305",
                    attrs: {
                      placeholder: _vm.$t("pc_eval_pleaseEnter").d("请输入"),
                      size: "small",
                      searchable: "",
                      clearable: "",
                    },
                    on: {
                      search: function ($event) {
                        return _vm.getList(1)
                      },
                    },
                    model: {
                      value: _vm.pager.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.pager, "keyword", $$v)
                      },
                      expression: "pager.keyword",
                    },
                  },
                  [
                    _c(
                      "yxt-select",
                      {
                        staticClass: "w100",
                        attrs: { slot: "prepend", size: "small" },
                        slot: "prepend",
                        model: {
                          value: _vm.pager.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.pager, "type", $$v)
                          },
                          expression: "pager.type",
                        },
                      },
                      [
                        _c("yxt-option", {
                          attrs: {
                            label: _vm
                              .$t("pc_eval_tip_username_search")
                              .d("姓名"),
                            value: 1,
                          },
                        }),
                        _c("yxt-option", {
                          attrs: {
                            label: _vm
                              .$t("pc_eval_tip_position_search")
                              .d("岗位"),
                            value: 2,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "select_table_wrap" },
        [
          _c("yxtbiz-eval-evaluator-table", {
            ref: "multipleTable",
            attrs: {
              datas: _vm.tableData,
              loading: _vm.loading,
              validate: _vm.validate,
              scene: _vm.scene,
              dataPermissionCode: _vm.evaluatorDataPermission,
              functionCode: _vm.functionCode,
              "is-save": true,
              id: _vm.id,
              isSelfTest: _vm.isSelfTest,
              relationList: _vm.relationList,
            },
            on: { "selection-change": _vm.handleSelectionChange },
          }),
          _c(
            "div",
            { staticClass: "clearfix pb15" },
            [
              _c("yxtbiz-eval-pager", {
                attrs: {
                  total: _vm.pager.total,
                  page: _vm.pager.offset,
                  limit: _vm.pager.limit,
                },
                on: {
                  "update:total": function ($event) {
                    return _vm.$set(_vm.pager, "total", $event)
                  },
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pager, "offset", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.pager, "limit", $event)
                  },
                  pagination: _vm.getList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("yxtbiz-eval-import-drawer", {
        ref: "importRelation",
        attrs: {
          title: _vm.importBatchTitle,
          "temp-url": _vm.tempUrl,
          "import-methods": _vm.importMethods,
        },
        on: {
          success: function ($event) {
            return _vm.getList(1)
          },
        },
      }),
      _c("yxtbiz-eval-step-footer", {
        attrs: { operation: _vm.operation, "footer-width": "960px" },
      }),
      _c("yxtbiz-eval-select-thirdparty-user", {
        attrs: {
          "show-model": [1, 4].includes(_vm.type),
          visible: _vm.addUsersVisible,
          "get-list": _vm.getUsers,
          "is-peer": _vm.showImportButton,
          defaultRaw: _vm.userListAll,
          functionCode: _vm.functionCode,
          dataPermissionCode: _vm.dataPermissionCode,
        },
        on: {
          "update:visible": function ($event) {
            _vm.addUsersVisible = $event
          },
          selected: _vm.handleSelectedUsers,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }